import { render, staticRenderFns } from "./header-nav-small.vue?vue&type=template&id=59a635c0&scoped=true"
import script from "./header-nav-small.vue?vue&type=script&lang=js"
export * from "./header-nav-small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a635c0",
  null
  
)

export default component.exports